import { Connection } from '../../pages/outreach/models/connection.model';

export class User {
  public readonly id!: number;
  public readonly username!: string;
  public readonly first_name!: string;
  public readonly last_name: string | undefined;
}

export class UserConnection extends User {
  public readonly connection!: Connection;
}

export class UserDetails extends User {
  public readonly email!: string;
  public readonly date_joined!: string;
  public readonly connection_display_name!: string;
  public profile_image_path!: string | null;
  public readonly last_login!: string;
}

export enum UserAccountType {
  SME = 1,
  CDFI = 2,
}
